import React, { useEffect, useState } from "react";
import { Wrapper } from "./LeadHistory.styled";
import { Column } from "@ant-design/plots";
import { Row, Col, Collapse } from "components/common";
import { callGetApiWithAuth } from "utils/api";
import { RightOutlined } from "@ant-design/icons";
import dropdown from "../../../../assets/images/dropdown.png";

const LeadHistory = ({ leadId }) => {
  const [graphData, setGraphData] = useState([]);
  const [LeadHistory, setLeadHistory] = useState([]);
  const { Panel } = Collapse;

  //   const self = [
  //     { monthName: "Jan", total: "9999" },
  //     { monthName: "Feb", total: "8888" },
  //     { monthName: "Mar", total: "7777" },
  //     { monthName: "Apr", total: "6666" },
  //     { monthName: "May", total: "5555" },
  //     { monthName: "Jun", total: "4444" },
  //     { monthName: "Jul", total: "3333" },
  //     { monthName: "Aug", total: "2222" },
  //     { monthName: "Sep", total: "1111" },
  //     { monthName: "Oct", total: "2222" },
  //     { monthName: "Nov", total: "3333" },
  //     { monthName: "Dec", total: "4444" },
  //   ];

  const config = {
    height: 200,
    data: graphData,
    xField: "monthName",
    yField: "total",
    label: {
      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },

    theme: {
      styleSheet: {
        brandColor: "#131f28",
      },
    },
  };
  const onSuccessPayHistory = (data) => {
    setLeadHistory(data);
  };
  const onFailPayHistory = (err) => {
    console.log(err);
  };

  const getPayHistory = () => {
    callGetApiWithAuth(`/leads/details/pay/expenses/history/${leadId}`, onSuccessPayHistory, onFailPayHistory);
  };
  const onSuccessLeadGraph = (data) => {
    setGraphData(data);
  };

  const onFailLeadGraph = (err) => {
    console.log(err);
  };
  const getLeadGraph = () => {
    callGetApiWithAuth(`/leads/details/lead/expenses/category/${leadId}`, onSuccessLeadGraph, onFailLeadGraph);
  };

  useEffect(() => {
    if (leadId) {
      getLeadGraph();
      getPayHistory();
    }
  }, [leadId]);
  return (
    <Wrapper>
      <Row gutter={[10, 10]}>
        <Col span={12} xs={24}>
          <Column {...config} />
        </Col>
        <Col span={12} xs={24}>
          <Collapse>
            {LeadHistory?.map((history, headerindex) => {
              return (
                <Panel
                  header={
                    <>
                      <div>
                        <b>{history?.lead?.name}</b> &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                        {new Date(history?.createdAt)?.toLocaleString()}
                      </div>
                    </>
                  }
                >
                  <div key={headerindex} className="data-Column">
                    <Col span={24}>
                      <h5 className="collapse-amount-header" style={{ color: "#000" }}>
                        ${parseInt(history?.amount)}
                      </h5>
                    </Col>
                  </div>
                </Panel>
              );
            })}
          </Collapse>
        </Col>
      </Row>
    </Wrapper>
  );
};

export default LeadHistory;
